export { default } from 'ember-cli-clipboard/helpers/is-clipboard-supported';
